import { RootState } from "../../Store";
import { useDispatch, useSelector } from "react-redux";
import { removeToast } from "../../Slice/ToastSlice";
import css from './ToastComponent.module.scss';

type Ix = {
  id: number,
  message: string,
}

const ToastComponent: React.FC = () => {

  const dispatch = useDispatch();
  const toasts = useSelector((state: RootState) => state.toast.toasts);

  const visibleToasts = toasts.slice(0, 3);
  const hiddenCount = toasts.length - visibleToasts.length;

  return (
    <div>
      <div className={css.container}>
        {visibleToasts.map((toast) => (
          <div key={toast.id} className={css.toast}>
            <span>{toast.message}</span>
            <button onClick={() => dispatch(removeToast(toast.id))} className={css.closeBtn}>
              <i className="bi bi-x" style={{fontSize: "35  px"}}></i>
            </button>
          </div>
        ))}

        {hiddenCount > 0 && (
          <div className={css.more}>
            +{hiddenCount} weitere
          </div>
        )}
      </div>
    </div>
  );
}

export default ToastComponent;